

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { ChiefComplaints } from './chiefcomplaint';

export interface PatientComplaintParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientComplaint {
    id?: any;
    regId:string;
    visitId:number;
    chiefComplaintId:string;
    duration:number;
    period:string;
    presentHistory:string;
    pastHistory:string;
    tenantId: any;
    branchId: any;
    complaint?: ChiefComplaints;
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientComplaintParameter[];
    links?: any;
    performingDoctor?:string;
    performingNurse?:string;
    admissionId?: number;
}

export interface ComplaintQuickSelect {
  
  chiefComplaintId:any;
  count:number;
}

export interface TypeOptions {
    value: number;
  }

  export interface PeriodOptions {
    value: string;
  } 


export abstract class PatientComplaintData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<PatientComplaint[]>;
    abstract get(url: string): Observable<any>;
    abstract create(url: string, data: PatientComplaint): Observable<PatientComplaint[]>;
    abstract update(url: string, data: PatientComplaint): Observable<PatientComplaint>;
    abstract delete(url: string): Observable<any>;
}
